const getApiBaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname.startsWith('10.') || hostname.startsWith('192.168.') || hostname === 'localhost') {
        return 'http://10.10.1.205:5018/';
    }

    return '/smej/';
};

export const API_URL = getApiBaseUrl();
// export const API_URL = "http://slujba.bga.gov.kg/api/"  // dev
// export const API_URL = "http://localhost:5018/"  // dev
export const FRONT_URL = "http://localhost:3000/" // dev
export const API_TEMPLATE_URL_GO = "http://localhost:8080/api/v1";
export const API_KEY_2GIS = 'cbc78ebd-5768-4bf4-8697-3b80dca26455';
// export const FRONT_URL ="http://eo.bga.kg";